<div class="content" spTooltip [tooltipText]="tooltip" [aboveNavbar]="true">
    <span class="light-wrapper" [style]="{ backgroundColor: color }"></span>
    <span class="light" [style]="{ backgroundColor: color }"></span>
</div>
